<template>
  <R3Title title="Reporting ❯ Site Admin"></R3Title> <!-- unicode U+276F : ❯ -->
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>

  <!-- <div style="margin: 20px 0 0 20px ; "> -->
  <!-- <div style="margin-bottom: -10px !important; ">
    <DxButton text="Add Site" width="150" style="background-color: rgb(255, 115, 0)" @click="addRecord"/>
  </div> -->
  <div>
    <TankStatusGrid :data-source="containers" :properties="properties" key-expr="containerId"
      :state-storage-key="storageKey" :default-column-config="defaultColumnConfig" :show-status-filters="!isOperator"
      :show-add-button="true"
      :column-fixing-enabled="!isOperator" :column-resizing-mode="dataGridColResizeMode" :height-offset="210"
      :use-default-column-config-only="false" @add-record="addRecordClick" @row-click="datagridRowClick" @refresh-data="refreshData"
      @grid-initialized="setGridInstance" @content-ready="dataReady" @select-container="onSelectContainer" />
  </div>
  </div>
</template>

<script>

import TankStatusGrid from '@/components/container/tank-status-grid.vue';
import R3Title from "@/components/base/page-title.vue";
import { DxButton, DxButtonGroup } from 'devextreme-vue';

export default {
  components: {
    R3Title,
    TankStatusGrid,
    // DxButton
  },
  created() {
    this.loadPageData();
  },
  mounted() {
    window.addEventListener('resize', this.setDimensions);
    this.setDimensions();
  },
  unmounted() {
    window.removeEventListener('resize', this.setDimensions);
  },
  data() {
    return {
      loading: true,
      selectedContainer: 0,
      fullContainer: 0,
      detailsVisible: false,
      typeId: {
        type: Number,
        default: 1
      },
      isOperator: {
        type: Boolean,
        default: false
      },
      dataGridColResizeMode: 'widget',
      dataGridInstance: null,
      datagridRowCount: 0,
      properties: [],
      containers: [],
      currentContainer: "",
      savedState: "",
      stateOpen: false,
      defaultState: "",
      storageKey: "grid_site_admin"
    };
  },
  computed: {
    
  },
  methods: {
    addRecordClick() {
      this.$router.push({ name: "containers-details", params: { id: 0 } });
    },
    onExporting(e) {
      e.fileName = "SiteAdminDataExport"
    },
    setGridInstance(e) {
      this.dataGridInstance = e.component;
      this.dataGridInstance.columnOption(0, 'allowHeaderFiltering', false);
    },

    removeFilter() {
      this.dataGridInstance.clearFilter();
      this.dataGridInstance.clearSorting();
    },

    refreshData() {
      this.loadData(true);
    },

    datagridRowClick(e) {
      // getVisibleRows().map(row => row.data); returns a list of the CURRENT PAGE OF THE GRID
      this.$store.dispatch("containers/setContainersFilteredList", e.component.getVisibleRows().map(row => row.data.containerId))
      // const selectedContainer = e.component.getSelectedRowsData()[0];
      console.log("open site key", e.component.getSelectedRowsData()[0]['containerId'])
      this.$router.push({
        name: "containers-details",
        params: { id: e.component.getSelectedRowsData()[0]['containerId'] },
      });
    },
    dataReady(e) {
      this.datagridRowCount = this.dataGridInstance.totalCount();
    },
    setDimensions() {
      const h = document.documentElement.clientHeight;
      this.datagridHeight = (h - 215) + 'px';
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {

          await Promise.all([
              this.$store.dispatch("containers/loadContainersStatusV2", { typeId: 1 }),
              this.$store.dispatch("properties/loadProperties"),
              this.$store.dispatch("userState/loadUserState", { id: 'containerStatusV2' })
          ])

          const keepProps = await this.$store.getters["properties/getProperties"]
              .filter(x => x.containerTypeId == 1 && x.uiShowList == true && x.appliesTo == 'C')
              .map(x => x.propertyName.toLowerCase())
              .sort();

          const numberProps = await this.$store.getters["properties/getProperties"]
              .filter(x => x.propertyType == 'NUMBER' || x.propertyType == 'DECIMAL')
              .map(x => x.propertyName.toLowerCase())
              .sort();

          const storeContainers = await this.$store.getters["containers/getContainersV2"];
          const c = JSON.parse(JSON.stringify(storeContainers));

          for (const i in c) {
              var propNames = Object.keys(c[i].properties);
              for (const j in propNames) {
                  if (keepProps.includes(propNames[j])) {
                      if (numberProps.includes(propNames[j]))
                          c[i][propNames[j]] = Number(c[i].properties[propNames[j]]);
                      else
                          c[i][propNames[j]] = c[i].properties[propNames[j]];
                  }
              }
              delete c[i].properties
          }

          this.containers = c;
          this.properties = keepProps;

      } catch (error) {
          this.error = error.message || "Unexpected Error.";
      } finally {
          this.loading = false;
      }
    },
  },
};

</script>

<style scoped>
/* .pageContent {
  max-height: 40vh;
  overflow: scroll;
} */

.ph {
  /* page header */
  height: 50px;
}

img {
  width: 80px;
  height: 80px;
}

p {
  text-align: left;
  margin-left: 4em;
  margin-top: 0em;
  font-weight: 300;
}

h6 {
  text-align: left;
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 0em;
  margin-left: 2.5em;
  font-weight: 300;
}

h4 {
  font-size: 26px;
  font-weight: 200;
  text-align: left;
  margin-top: 0.5em;
  margin-bottom: 0em;
  margin-left: 1em;
}

.prop {
  margin: 10px 60px 0 60px;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: red;
  color: white;
  text-align: center;
}

.mininote {
  text-align: left;
  font-size: 11px;
  /* margin-top:8px; */
  /* margin-bottom:0em; */
  /* margin-left:2.5em;  */
  font-weight: 300;
  color: rgb(255, 125, 0);
}

.subtitle pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}
</style>
